module.exports = __webpack_public_path__ + "static/realestate-c19ddc892f9bebe025963407a177dd4a.png";